export default __webpack_public_path__ + "static/media/prev-NDNU-1.9cdb6e0c.png";